import { useState } from "react"
import toast from "react-hot-toast"
import Navbar from "../components/Navbar"
import NFTCard from "../components/NFTCard"
import Pagination from "../components/Pagination"
import { useNFTs, usePurchaseNFT } from "../hooks/useNFTs"

export default function Dashboard() {
  const [currentPage, setCurrentPage] = useState(1)
  const { data, isLoading, error, refetch } = useNFTs(currentPage, 9)
  const purchaseMutation = usePurchaseNFT()

  const nfts = data?.nfts || []
  const pagination = data?.pagination

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handlePurchaseSuccess = async (purchaseDetails) => {
    console.log('=== handlePurchaseSuccess called ===')
    console.log('Purchase details:', {
      tokenId: purchaseDetails.tokenId,
      transactionHash: purchaseDetails.transactionHash,
      buyer: purchaseDetails.buyer,
      pricePaid: purchaseDetails.pricePaid
    })

    try {
      const payload = {
        nftId: purchaseDetails.tokenId,
        transactionHash: purchaseDetails.transactionHash,
        buyer: purchaseDetails.buyer,
        pricePaid: purchaseDetails.pricePaid,
      }

      console.log('Sending to backend:', payload)

      const result = await purchaseMutation.mutateAsync(payload)

      console.log('Backend response:', result)

      // Show success toast notification
      toast.success(`NFT #${purchaseDetails.tokenId} purchased successfully! 🎉`, {
        duration: 5000,
        style: {
          background: '#1a1a2e',
          color: '#00d9ff',
          border: '1px solid #00d9ff',
          padding: '16px',
        },
      })

      // Refresh NFT list to show updated ownership
      setTimeout(() => {
        refetch()
      }, 2000)

      return result // Return the result so the promise resolves
    } catch (err) {
      console.error('=== Backend update failed ===')
      console.error('Error object:', err)
      console.error('Error response:', err.response)
      console.error('Error response data:', err.response?.data)
      console.error('Error response status:', err.response?.status)
      console.error('Error message:', err.message)

      // Show detailed error
      const errorMessage = err.response?.data?.message || err.message || 'Unknown error'
      const errorDebug = err.response?.data?.debug ? JSON.stringify(err.response.data.debug) : ''

      // Show error toast notification
      toast.error(`Purchase failed: ${errorMessage}${errorDebug ? '\n' + errorDebug : ''}`, {
        duration: 8000,
        style: {
          background: '#1a1a2e',
          color: '#ff4444',
          border: '1px solid #ff4444',
          padding: '16px',
          maxWidth: '500px',
        },
      })

      throw err // Re-throw so the hook knows it failed
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
  <Navbar />

 <div
  className="flex-1 bg-cover bg-center bg-no-repeat bg-fixed"
  style={{ backgroundImage: "url('/images/dash-bg.jpg')" }}
>
<div className="max-w-7xl mx-auto px-4 py-8">
        {error && (
          <div className="mb-4 p-4 bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg">
            Failed to load NFTs. Please try again.
          </div>
        )}

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="text-lg text-text-secondary">Loading NFTs...</div>
          </div>
        ) : nfts && nfts.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {nfts.map((nft) => (
                <NFTCard
                  key={nft.id}
                  nft={nft}
                  onPurchaseSuccess={handlePurchaseSuccess}
                  isOwned={nft.isOwned}
                />
              ))}
            </div>
            <Pagination pagination={pagination} onPageChange={handlePageChange} />
          </>
        ) : (
          <div className="text-center py-12">
            <p className="text-text-secondary text-lg">No NFTs available yet.</p>
          </div>
        )}
      </div>
      </div>
      
    </div>
  )
}
